import React from 'react'
import PropTypes from 'prop-types'

import WithDraggableList from 'Pods/Shared/Hocs/WithDraggableList'

function UserSidebarScrollablePills({ items, keyPrefix }) {
  return (
    <ul className="job-list-item__labels">
      {items.map((label) => (
        <li key={`${keyPrefix}-item-${label}`}>
          <span className="label label--info label--grey">{label}</span>
        </li>
      ))}
    </ul>
  )
}

UserSidebarScrollablePills.propTypes = {
  keyPrefix: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
}

export default WithDraggableList(UserSidebarScrollablePills)
